var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import instantsearch from 'instantsearch.js';
import { liteClient as algoliasearch } from 'algoliasearch/lite';
import { searchBox, infiniteHits, stats, refinementList, toggleRefinement, rangeSlider, } from 'instantsearch.js/es/widgets';
import { detailUtil } from '@utils';
import { addToCart, addToFavorites, setScrollbarWidth } from '@vape-shop/blocks';
import { withAkkuIntentBoost } from './akku-intent';
var blockWrapper = document.querySelector('.wp-block-vape-shop-algoliasearch');
var algoliaClient = algoliasearch(algolia_vars.app_id, algolia_vars.api_key);
var minimumQueryLength = 2;
var searchDebounceMs = 200;
var searchDebounceTimer = null;
var queryLength = function (query) { return String(query !== null && query !== void 0 ? query : '').trim().length; };
var clearSearchDebounce = function () {
    if (searchDebounceTimer !== null) {
        clearTimeout(searchDebounceTimer);
        searchDebounceTimer = null;
    }
};
// Prevent empty and one-character searches, including requests that bypass the search box hook.
var searchClient = __assign(__assign({}, algoliaClient), { search: function (requests) {
        if (requests.every(function (_a) {
            var params = _a.params;
            return queryLength(params === null || params === void 0 ? void 0 : params.query) < minimumQueryLength;
        })) {
            return Promise.resolve({
                results: requests.map(function (_a) {
                    var _b;
                    var params = _a.params;
                    return ({
                        hits: [],
                        nbHits: 0,
                        nbPages: 0,
                        page: 0,
                        processingTimeMS: 0,
                        hitsPerPage: 0,
                        exhaustiveNbHits: true,
                        exhaustiveTypo: true,
                        query: String((_b = params === null || params === void 0 ? void 0 : params.query) !== null && _b !== void 0 ? _b : ''),
                        params: '',
                    });
                }),
            });
        }
        return algoliaClient.search(requests.map(function (request) { return withAkkuIntentBoost(request, algolia_vars.index_name); }));
    } });
var filters = document.querySelectorAll('.wp-block-vape-shop-algoliasearch__filter');
var populars = document.querySelectorAll('.wp-block-vape-shop-algoliasearch__popular-button');
var popup = document.querySelector('.wp-block-vape-shop-algoliasearch__popup');
var header = document.querySelector('.wp-block-vape-shop-header');
var searchBoxContainer = document.querySelector('.wp-block-vape-shop-algoliasearch__searchbox');
var hitsContainer = document.querySelector('.wp-block-vape-shop-algoliasearch__hits');
var lastScrollTop = 0;
var priceAmount = function (price) {
    var number = parseFloat(price);
    if (Number.isNaN(number))
        return null;
    var formattedPrice = number.toFixed(2).replace('.', ',');
    if (!formattedPrice)
        return null;
    return "".concat(formattedPrice, " \u20AC");
};
var search = instantsearch({
    indexName: algolia_vars.index_name,
    searchClient: searchClient,
    insights: true,
    future: { preserveSharedStateOnUnmount: true },
});
search.addWidgets([
    searchBox({
        container: searchBoxContainer,
        placeholder: 'Suchen...',
        showReset: false,
        showLoadingIndicator: false,
        queryHook: function (query, hook) {
            var _a;
            var normalizedQuery = (_a = query === null || query === void 0 ? void 0 : query.trim()) !== null && _a !== void 0 ? _a : '';
            clearSearchDebounce();
            if (normalizedQuery.length < minimumQueryLength) {
                blockWrapper.classList.remove('results');
                return;
            }
            searchDebounceTimer = setTimeout(function () {
                blockWrapper.classList.add('results');
                hook(query);
                searchDebounceTimer = null;
            }, searchDebounceMs);
        },
    }),
    infiniteHits({
        container: hitsContainer,
        templates: {
            empty: function () { return 'Keine Ergebnisse'; },
            showMoreText: function () { return 'Mehr anzeigen'; },
            item: function (hit, _a) {
                var _b;
                var html = _a.html, components = _a.components;
                var addToFavoritesButtonClasses = 'add-to-favorites';
                // @ts-ignore
                if ((_b = window.vapeShopFavorites) === null || _b === void 0 ? void 0 : _b.includes(hit.post_id.toString())) {
                    addToFavoritesButtonClasses += ' active';
                }
                var isSingleProduct = hit.product_type !== 'variable' && hit.product_type !== 'bundle';
                var canAddToCart = isSingleProduct;
                return html(templateObject_7 || (templateObject_7 = __makeTemplateObject(["<article class=\"vape-shop-product-card\">\n          <a href=\"", "\" class=\"vape-shop-product-card__link\">\n            <div class=\"vape-shop-product-card__image\">\n              <img src=\"", "\" alt=\"", "\" />\n              <div class=\"vape-shop-product-card__top\">\n                <div class=\"vape-shop-product-card__badges\"></div>\n                <button data-id=\"", "\" class=\"", "\">\n                  <svg aria-hidden=\"true\" role=\"presentation\" focusable=\"false\">\n                    <use href=\"#favorites\"></use>\n                  </svg>\n                </button>\n              </div>\n            </div>\n            <div class=\"vape-shop-product-card__info\">\n              <h3 class=\"vape-shop-product-card__title\">\n                ", "\n              </h3>\n              <div class=\"vape-shop-product-card__bottom\">\n                <span class=\"vape-shop-product-card__price\">\n                  ", "\n                </span>\n                ", "\n              </div>\n            </div>\n          </a>\n        </article>"], ["<article class=\"vape-shop-product-card\">\n          <a href=\"", "\" class=\"vape-shop-product-card__link\">\n            <div class=\"vape-shop-product-card__image\">\n              <img src=\"", "\" alt=\"", "\" />\n              <div class=\"vape-shop-product-card__top\">\n                <div class=\"vape-shop-product-card__badges\"></div>\n                <button data-id=\"", "\" class=\"", "\">\n                  <svg aria-hidden=\"true\" role=\"presentation\" focusable=\"false\">\n                    <use href=\"#favorites\"></use>\n                  </svg>\n                </button>\n              </div>\n            </div>\n            <div class=\"vape-shop-product-card__info\">\n              <h3 class=\"vape-shop-product-card__title\">\n                ", "\n              </h3>\n              <div class=\"vape-shop-product-card__bottom\">\n                <span class=\"vape-shop-product-card__price\">\n                  ", "\n                </span>\n                ", "\n              </div>\n            </div>\n          </a>\n        </article>"])), hit.url, hit.image_small, hit.title, hit.post_id, addToFavoritesButtonClasses, components.Highlight({ attribute: 'title', hit: hit }), hit.product_type === 'variable'
                    ? html(templateObject_1 || (templateObject_1 = __makeTemplateObject(["<ins><span class=\"amount\">", "</span></ins>"], ["<ins><span class=\"amount\">", "</span></ins>"])), hit.price_label) : hit.on_sale
                    ? html(templateObject_2 || (templateObject_2 = __makeTemplateObject(["<del\n                            ><span class=\"amount\">", "</span></del\n                          >\n                          <ins><span class=\"amount\">", "</span></ins>"], ["<del\n                            ><span class=\"amount\">", "</span></del\n                          >\n                          <ins><span class=\"amount\">", "</span></ins>"])), priceAmount(hit.regular_price), priceAmount(hit.sale_price)) : html(templateObject_3 || (templateObject_3 = __makeTemplateObject(["<ins>\n                          <span class=\"amount\">", "</span>\n                        </ins>"], ["<ins>\n                          <span class=\"amount\">", "</span>\n                        </ins>"])), priceAmount(hit.regular_price)), hit.in_stock && html(templateObject_6 || (templateObject_6 = __makeTemplateObject(["<button\n                  class=\"add-to-cart\"\n                  data-action=\"", "\"\n                  data-product=\"", "\"\n                  data-variation=\"", "\"\n                >\n                  ", "\n                </button>"], ["<button\n                  class=\"add-to-cart\"\n                  data-action=\"", "\"\n                  data-product=\"", "\"\n                  data-variation=\"", "\"\n                >\n                  ", "\n                </button>"])), canAddToCart ? 'add-to-cart' : 'permalink', hit.product_type !== 'variation' ? hit.post_id : hit.parent_id, hit.post_id, isSingleProduct
                    ? html(templateObject_4 || (templateObject_4 = __makeTemplateObject(["<svg role=\"presentation\" focusable=\"false\">\n                        <use href=\"#ui/plus\"></use>\n                      </svg>"], ["<svg role=\"presentation\" focusable=\"false\">\n                        <use href=\"#ui/plus\"></use>\n                      </svg>"]))) : html(templateObject_5 || (templateObject_5 = __makeTemplateObject(["<svg\n                        xmlns=\"http://www.w3.org/2000/svg\"\n                        width=\"8\"\n                        height=\"13\"\n                        viewBox=\"0 0 8 2\"\n                        fill=\"none\"\n                      >\n                        <path d=\"M2 1L-7.45058e-09 1\" stroke=\"currentColor\" stroke-width=\"1.5\" />\n                        <path d=\"M5 1L3 1\" stroke=\"currentColor\" stroke-width=\"1.5\" />\n                        <path d=\"M8 1L6 1\" stroke=\"currentColor\" stroke-width=\"1.5\" />\n                      </svg>"], ["<svg\n                        xmlns=\"http://www.w3.org/2000/svg\"\n                        width=\"8\"\n                        height=\"13\"\n                        viewBox=\"0 0 8 2\"\n                        fill=\"none\"\n                      >\n                        <path d=\"M2 1L-7.45058e-09 1\" stroke=\"currentColor\" stroke-width=\"1.5\" />\n                        <path d=\"M5 1L3 1\" stroke=\"currentColor\" stroke-width=\"1.5\" />\n                        <path d=\"M8 1L6 1\" stroke=\"currentColor\" stroke-width=\"1.5\" />\n                      </svg>"])))));
            },
        },
    }),
    stats({
        container: '.wp-block-vape-shop-algoliasearch__stats',
        templates: {
            text: function (data, _a) {
                var html = _a.html;
                if (data.hasManyResults) {
                    return html(templateObject_8 || (templateObject_8 = __makeTemplateObject(["<span>", " Produkte gefunden f\u00FCr \u201E", "\u201C</span>"], ["<span>", " Produkte gefunden f\u00FCr \u201E", "\u201C</span>"])), data.nbHits, data.query);
                }
                if (data.hasOneResult) {
                    return html(templateObject_9 || (templateObject_9 = __makeTemplateObject(["<span>", " Produkt gefunden f\u00FCr \u201E", "\u201C</span>"], ["<span>", " Produkt gefunden f\u00FCr \u201E", "\u201C</span>"])), data.nbHits, data.query);
                }
                var input = searchBoxContainer.querySelector('.ais-SearchBox-input');
                var query = data.query.trim() || (input === null || input === void 0 ? void 0 : input.value.trim()) || '';
                return html(templateObject_10 || (templateObject_10 = __makeTemplateObject(["<span>Keine Ergebnisse f\u00FCr \u201E", "\u201C gefunden.</span>"], ["<span>Keine Ergebnisse f\u00FCr \u201E", "\u201C gefunden.</span>"])), query);
            },
        },
    }),
]);
filters.forEach(function (filter) {
    var attribute = filter.getAttribute('data-attribute');
    var type = filter.getAttribute('data-type');
    var container = filter.querySelector('.wp-block-vape-shop-algoliasearch__filter-content');
    if (!attribute || !container || !type)
        return;
    if (type === 'toggle') {
        search.addWidgets([
            toggleRefinement({
                container: container,
                attribute: attribute,
                templates: { labelText: '' },
            }),
        ]);
    }
    else {
        var handler_1 = filter.querySelector('.wp-block-vape-shop-algoliasearch__filter-label');
        handler_1.addEventListener('click', function () {
            if (window.innerWidth > 783) {
                detailUtil.toggle({ handler: handler_1, content: container });
            }
            else {
                container.classList.add('open-mobile');
                blockWrapper.classList.add('open-filter');
                header === null || header === void 0 ? void 0 : header.classList.remove('scroll-down');
            }
        });
        if (window.innerWidth <= 783) {
            var closeButtons = container.querySelectorAll('.filter-popup__close, .wp-block-vape-shop-algoliasearch__filter-submit');
            closeButtons === null || closeButtons === void 0 ? void 0 : closeButtons.forEach(function (button) {
                button.addEventListener('click', function () {
                    container.classList.remove('open-mobile');
                    blockWrapper.classList.remove('open-filter');
                });
            });
        }
        if (type === 'checkbox') {
            var searchable = filter.getAttribute('data-searchable') === 'true';
            search.addWidgets([
                refinementList({
                    container: container,
                    attribute: attribute,
                    searchable: searchable,
                    limit: searchable ? 100 : 20,
                    transformItems: function (items) {
                        filter.toggleAttribute('hidden', items.length === 0);
                        return items;
                    },
                    templates: {
                        item: function (data, _a) {
                            var html = _a.html;
                            return html(templateObject_11 || (templateObject_11 = __makeTemplateObject(["<label class=\"ais-RefinementList-label\">\n                <div class=\"ais-RefinementList-checkbox\">\n                  <input type=\"checkbox\" value=\"", "\" checked=\"", "\" />\n                  <span></span>\n                </div>\n                <span class=\"ais-RefinementList-labelText\">", "</span>\n                <span class=\"ais-RefinementList-count\">", "</span>\n              </label>"], ["<label class=\"ais-RefinementList-label\">\n                <div class=\"ais-RefinementList-checkbox\">\n                  <input type=\"checkbox\" value=\"", "\" checked=\"", "\" />\n                  <span></span>\n                </div>\n                <span class=\"ais-RefinementList-labelText\">", "</span>\n                <span class=\"ais-RefinementList-count\">", "</span>\n              </label>"])), data.value, data.isRefined, data.label, data.count);
                        },
                    },
                }),
            ]);
        }
        else if (type === 'range') {
            var min = filter.getAttribute('data-min');
            var max = filter.getAttribute('data-max');
            search.addWidgets([
                rangeSlider({
                    container: container,
                    attribute: attribute,
                    min: min ? parseFloat(min) : 0,
                    max: max ? parseFloat(max) : 30,
                    precision: 2,
                    step: 0.1,
                }),
            ]);
        }
    }
});
searchBoxContainer.addEventListener('click', function (evt) {
    var target = evt.target;
    var activeClass = 'wp-block-vape-shop-algoliasearch-active';
    if (!search.started) {
        search.start();
    }
    if (target === null || target === void 0 ? void 0 : target.classList.contains('wp-block-vape-shop-algoliasearch__reset')) {
        clearSearchDebounce();
        blockWrapper.classList.remove(activeClass, 'results');
        document.body.classList.remove('no-scroll');
        search.helper.clearRefinements();
        search.helper.setQuery('').search();
    }
    else {
        setScrollbarWidth();
        blockWrapper.classList.add(activeClass);
        header === null || header === void 0 ? void 0 : header.classList.remove('scroll-down');
        document.body.classList.add('no-scroll');
    }
});
populars.forEach(function (popular) {
    popular.addEventListener('click', function (evt) {
        var target = evt.target;
        var value = target.innerText;
        if (value) {
            search.renderState[algolia_vars.index_name].searchBox.refine(value);
        }
    });
});
hitsContainer.addEventListener('click', function (evt) {
    var target = evt.target;
    var addToFavoritesButton = target === null || target === void 0 ? void 0 : target.closest('.add-to-favorites');
    var addToCartButton = target === null || target === void 0 ? void 0 : target.closest('[data-action="add-to-cart"]');
    if (addToCartButton) {
        addToCart({ evt: evt, button: addToCartButton });
    }
    else if (addToFavoritesButton) {
        addToFavorites({ evt: evt, button: addToFavoritesButton });
    }
});
popup.addEventListener('scroll', function () {
    var currentScrollTop = popup.scrollTop;
    if (currentScrollTop < 74) {
        header === null || header === void 0 ? void 0 : header.classList.remove('scroll-down');
        return;
    }
    if (Math.abs(currentScrollTop - lastScrollTop) > 50) {
        header === null || header === void 0 ? void 0 : header.classList.toggle('scroll-down', currentScrollTop > lastScrollTop);
        lastScrollTop = currentScrollTop;
    }
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
